export const slide1 = require('images/about-us/slide1.webp');
export const slide2 = require('images/about-us/slide2.webp');
export const slide3 = require('images/about-us/slide3.webp');
export const slide4 = require('images/about-us/slide4.webp');
export const slide5 = require('images/about-us/slide5.webp');
export const slide6 = require('images/about-us/slide6.webp');
export const slide7 = require('images/about-us/slide7.webp');
export const slide8 = require('images/about-us/slide8.webp');
export const slide9 = require('images/about-us/slide9.webp');
export const slide10 = require('images/about-us/slide10.webp');
export const slide11 = require('images/about-us/slide11.webp');
export const slide12 = require('images/about-us/slide12.webp');
export const slide13 = require('images/about-us/slide13.webp');
export const slide14 = require('images/about-us/slide14.webp');
export const slide15 = require('images/about-us/slide15.webp');
export const slide16 = require('images/about-us/slide16.webp');
export const slide17 = require('images/about-us/slide17.webp');
export const slide18 = require('images/about-us/slide18.webp');
export const slide19 = require('images/about-us/slide19.webp');

export const bgImageHeader = require('images/about-us/bgImageHeader.webp');
export const bgImageLeadership = require('images/about-us/bgImageLeadership.webp');
export const leadership = require('images/about-us/Leadership.webp');
export const bgImageProudMembers = require('images/about-us/bgImageProudMembers.webp');

export const photoAndrianLeca = require('images/about-us/Andrian_Leca.webp');
export const photoAlexandrinPatron = require('images/about-us/Alexandrin_Patron.webp');
export const photoButchWilson = require('images/about-us/Butch_Wilson.webp');
export const photoDanaSinger = require('images/about-us/Dana_Singer.webp');
export const photoEcaterinaSharapova = require('images/about-us/Ecaterina_Sharapova.webp');
export const photoElenaLuca = require('images/about-us/Elena_Luca.webp');
export const photoJosephDiMelis = require('images/about-us/Joseph_DiMelis.webp');
export const photoMihaiBudac = require('images/about-us/Mihai_Budac.webp');
export const photoRuxandraCreizan = require('images/about-us/Ruxandra_Creizan.webp');
export const photoSergheiBusmachiu = require('images/about-us/Serghei_Busmachiu.webp');
export const photoDumitruBoscanean = require('images/about-us/Dumitru_Boscanean.webp');
export const photoValeriaLozovanu = require('images/about-us/Valeria_Lozovanu.webp');
export const photoAnthonyByfield = require('images/about-us/Anthony_Byfield.webp');
export const photoChristopherJohnson = require('images/about-us/Christopher_Johnson.webp');
export const photoJohnWinder = require('images/about-us/John_Winder.webp');
export const photoRajTank = require('images/about-us/Raj_Tank.webp');
export const photoRandallBrooks = require('images/about-us/Randall_Brooks.webp');
export const photoRyanWheeler = require('images/about-us/Ryan_Wheeler.webp');
export const photoSinaMohseninejad = require('images/about-us/Sina_Mohseninejad.webp');
export const photoTylerDuclos = require('images/about-us/Tyler_Duclos.webp');
export const photoDenisMezer = require('images/about-us/Denis_Mezer.webp');
export const photoAndreiUreche = require('images/about-us/Andrei_Ureche.webp');
export const photoBenjimenSkiba = require('images/about-us/Benjimen_Skiba.webp');
export const photoJohnathanDoyle = require('images/about-us/Johnathan_Doyle.webp');
export const photoMattLutton = require('images/about-us/Matt_Lutton.webp');
export const photoMatthewFranklin = require('images/about-us/Matthew_Franklin.webp');
export const photoQuranOsiris = require('images/about-us/Quran_Osiris.webp');
export const photoSergiuCurea = require('images/about-us/Sergiu_Curea.webp');
export const photoWilliamCarithers = require('images/about-us/William_Carithers.webp');
export const photoWilliamOld = require('images/about-us/William_Old.webp');
export const photoDavidSumner = require('images/about-us/David_Sumner.webp');
export const photoMohammedSadiqMabeko = require('images/about-us/Mohammed_Sadiq_Mabeko.webp');
export const photoAlexandruRailean = require('images/about-us/Alexandru_Railean.webp');
export const photoIonUntila = require('images/about-us/Ion_Untila.webp');
export const photoIonutCiobanu = require('images/about-us/Ionut_Ciobanu.webp');
export const photoIvanPoclitari = require('images/about-us/Ivan_Poclitari.webp');
export const photoDanielaJurja = require('images/about-us/Cristina_Cocieru.webp');
export const photoCristinaCocieru = require('images/about-us/Daniela_Jurja.webp');
export const photoVadimUncu = require('images/about-us/Vadim_Uncu.webp');

export const associationLogo1 = require('images/about-us/associationLogo1.webp');
export const associationLogo2 = require('images/about-us/associationLogo2.webp');
export const associationLogo3 = require('images/about-us/associationLogo3.webp');
export const associationLogo4 = require('images/about-us/associationLogo4.webp');
export const associationLogo5 = require('images/about-us/associationLogo5.webp');
export const associationLogo6 = require('images/about-us/associationLogo6.webp');
export const associationLogo7 = require('images/about-us/associationLogo7.webp');
export const associationLogo8 = require('images/about-us/associationLogo8.webp');
export const associationLogo9 = require('images/about-us/associationLogo9.webp');
export const associationLogo10 = require('images/about-us/associationLogo10.webp');
export const associationLogo11 = require('images/about-us/associationLogo11.webp');
export const associationLogo12 = require('images/about-us/associationLogo12.webp');

export const ourPartnersLogo1 = require('images/about-us/ourPartnersLogo1.webp');
export const ourPartnersLogo2 = require('images/about-us/ourPartnersLogo2.webp');
export const ourPartnersLogo3 = require('images/about-us/ourPartnersLogo3.webp');
export const ourPartnersLogo4 = require('images/about-us/ourPartnersLogo4.webp');
export const ourPartnersLogo5 = require('images/about-us/ourPartnersLogo5.webp');
export const ourPartnersLogo6 = require('images/about-us/ourPartnersLogo6.webp');
export const ourPartnersLogo9 = require('images/about-us/ourPartnersLogo9.webp');
export const ourPartnersLogo10 = require('images/about-us/ourPartnersLogo10.webp');
export const ourPartnersLogo11 = require('images/about-us/ourPartnersLogo11.webp');
export const ourPartnersLogo12 = require('images/about-us/ourPartnersLogo12.webp');
export const ourPartnersLogo13 = require('images/about-us/ourPartnersLogo13.webp');
export const ourPartnersLogo14 = require('images/about-us/ourPartnersLogo14.webp');
export const ourPartnersLogo15 = require('images/about-us/ourPartnersLogo15.webp');
export const ourPartnersAlaska = require('images/about-us/ourPartnersAlaska.webp');
export const ourPartnersAlaskaTelecom = require('images/about-us/ourPartnersAlaskaTelecom.webp');
export const ourPartnersAstoundLogo = require('images/about-us/ourPartnersAstoundLogo.webp');
export const ourPartnersAptitudeLogo = require('images/about-us/ourPartnersAptitudeLogo.webp');
export const ourPartnersATTLogo = require('images/about-us/ourPartnersATTLogo.webp');
export const ourPartnersFrontierCommunicationsLogo = require('images/about-us/ourPartnersFrontierCommunicationsLogo.webp');
export const ourPartnersAlticeLogo = require('images/about-us/ourPartnersAlticeLogo.webp');
export const ourPartnersFatbeamLogo = require('images/about-us/ourPartnersFatbeamLogo.webp');
export const ourPartnersEricssonLogo = require('images/about-us/ourPartnersEricssonLogo.webp');
export const ourPartnersMaxxSouthLogo = require('images/about-us/ourPartnersMaxxSouthLogo.webp');
export const ourParnersSpectrumLogo = require('images/about-us/ourParnersSpectrumLogo.webp');
export const ourPartnersCharterLogo = require('images/about-us/ourPartnersCharterLogo.webp');
export const ourPartnersComcastLogo = require('images/about-us/ourPartnersComcastLogo.webp');
export const ourPartnersClearwaveLogo = require('images/about-us/ourPartnersClearwaveLogo.webp');
export const ourPartnersConsolidatedLogo = require('images/about-us/ourPartnersConsolidatedLogo.webp');
export const ourPartnersDishLogo = require('images/about-us/ourPartnersDishLogo.webp');
export const ourPartnersWyyerdLogo = require('images/about-us/ourPartnersWyyerdLogo.webp');
export const ourPartnersLumosLogo = require('images/about-us/ourPartnersLumosLogo.webp');
export const ourPartnersTeslaLogo = require('images/about-us/ourPartnersTeslaLogo.webp');

export const teamDescriptionBgPhoto = require('images/about-us/teamDescriptionBgPhoto.webp');
export const teamDescriptionPhoto = require('images/about-us/teamDescriptionPhoto.webp');

export const photoJasonMcCoy = require('images/about-us/photoJasonMcCoy.webp');
export const photoJuanDelCalvo = require('images/about-us/photoJuanDelCalvo.webp');
export const photoCharlesHouser = require('images/about-us/photoCharlesHouser.webp');
export const photoTatianaLeahovici = require('images/about-us/Tatiana_Leahovici.webp');
export const photoEdwardJares = require('images/about-us/photoEdwardJares.webp');
export const photoKyleClausen = require('images/about-us/photoKyleClausen.webp');
export const photoCraigTonks = require('images/about-us/photoCraigTonks.webp');
export const photoIvanGalkin = require('images/about-us/Ivan_Galkin.webp');
export const photoRandyMantione = require('images/about-us/Randy_Mantione.webp');
export const photoBrentCollins = require('images/about-us/Brent_Collins.webp');
export const photoIgorPapo = require('images/about-us/Igor_Papo.webp');
export const photoJohnathanMathewL = require('images/about-us/Johnathan_Mathew_L.webp');
export const photoSteveSizemore = require('images/about-us/Steve_Sizemore.webp');
export const photoAlexandruBuse = require('images/about-us/Alexandru_Buse.webp');
export const photoBulatOleg = require('images/about-us/Bulat_Oleg.webp');
export const photoBrianBertrand = require('images/about-us/Brian_Bertrand.webp');
export const photoMatthewStewart = require('images/about-us/Matthew_Stewart.webp');
export const photoViktorPilgun = require('images/about-us/Viktor_Pilgun.webp');
export const photoMarkClemens = require('images/about-us/Mark_Clemens.webp');
export const photoJuanFranciscoNin = require('images/about-us/Juan_Francisco_Nin.webp');
export const photoDanielArmas = require('images/about-us/Daniel_Armas.webp');
export const photoLenardSweeting = require('images/about-us/Lenard_Sweeting.webp');
export const photoMihaelaPoiata = require('images/about-us/Mihaela_Poiata.webp');
export const photoDariaGardas = require('images/about-us/Daria_Gardas.webp');
export const photoDorinGora = require('images/about-us/Dorin_Gora.webp');
export const photoTatianaIlian = require('images/about-us/Tatiana_Ilian.webp');
export const photoAnaPaduret = require('images/about-us/Ana_Paduret.webp');
export const photoSergiuChitanu = require('images/about-us/Sergiu_Chitanu.webp');
export const photoAnaBurlac = require('images/about-us/photoAnaBurlac.webp');
export const photoConstantinCeban = require('images/about-us/photoConstantinCeban.webp');
export const photoGlebReznicenco = require('images/about-us/photoGlebReznicenco.webp');
export const photoEugeniuCupcinenco = require('images/about-us/photoEugeniuCupcinenco.webp');
export const photoMihailUlinici = require('images/about-us/photoMihailUlinici.webp');
export const photoOctavianMantaluta = require('images/about-us/photoOctavianMantaluta.webp');
export const photoOxanaMagalu = require('images/about-us/photoOxanaMagalu.webp');
export const photoRodionDanu = require('images/about-us/photoRodionDanu.webp');
export const photoRuslanBaxanean = require('images/about-us/photoRuslanBaxanean.webp');
export const photoSergiuTasmali = require('images/about-us/photoSergiuTasmali.webp');
export const photoValeriaTulbure = require('images/about-us/photoValeriaTulbure.webp');
export const photoOlgaMelnic = require('images/about-us/photoOlgaMelnic.webp');
export const photoAlexandruBacinschii = require('images/about-us/photoAlexandruBacinschii.webp');
export const photoDumitruPinzari = require('images/about-us/photoDumitruPinzari.webp');
export const photoEdgarDacin = require('images/about-us/photoEdgarDacin.webp');
